import type { SessionId } from '../../domain/Session';
import { createCommand } from '../../utils';
import { networkMapQuery, sessionNetworkQuery } from '../queries';
import { sessionNetworkLoaded } from '../state';

// Loads the network data of a single session (for the street view mini map), which is much lighter
// than the whole organization's network the full map loads.
export const LoadSessionNetworkDataCommand = createCommand<{ sessionId: SessionId }>(
    'SESSIONS_MAP/LOAD_SESSION_NETWORK_DATA',
    async ({ sessionId }, { dispatch, extra, getState }) => {
        const state = getState();

        // already available, either because the full map loaded the whole network or from an earlier call
        if (networkMapQuery(state) || sessionNetworkQuery(sessionId)(state)) {
            return;
        }

        const network = await extra.externalNetworkMap.loadSessionNetworkData(sessionId);

        dispatch(sessionNetworkLoaded({ sessionId, network }));
    },
);
